// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2f0VJ","question":"Question_question__3Kw_X","description":"Question_description__28kfJ"};